import { useEffect, useRef, useState } from "react"
import { getEventsByUserAndEvent } from "../../../utils/apis/user-service"
import { useAuth } from "../../../utils/context/AuthContext"

export const useGetEvents = (patient_id: string | null, event_types: string | string[]) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [events, setEvents] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)
    
    // Use ref to track previous event types and prevent infinite loops
    const prevEventTypesRef = useRef<string>('')
    const currentEventTypesString = Array.isArray(event_types) ? event_types.sort().join(',') : event_types

    useEffect(() => {
        if (!patient_id || !idToken) {
            setIsLoading(false)
            return
        }

        // Only fetch if event types have actually changed
        if (prevEventTypesRef.current === currentEventTypesString) {
            return
        }

        prevEventTypesRef.current = currentEventTypesString

        const fetchEvents = async () => {
            try {
                // Convert single event_type to array for consistent handling
                const eventTypesArray = Array.isArray(event_types) ? event_types : [event_types]
                
                // Fetch all events in parallel
                const eventPromises = eventTypesArray.map(eventType => 
                    getEventsByUserAndEvent(idToken, patient_id, eventType)
                )
                
                const allEventsArrays = await Promise.all(eventPromises)
                
                // Flatten all events into a single array
                const combinedEvents = allEventsArrays.flat()
                
                console.log('Combined events:', combinedEvents)
                setEvents(combinedEvents)
            } catch (err: any) {
                console.error('Error fetching events:', err)
                setError(err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchEvents()

    }, [patient_id, idToken, currentEventTypesString])

    return { events, isLoading, error }
}